import { useNavigate } from "react-router-dom";
import "../../../../DrugAssignmentBatchRelease/DrugAssignment.css";
import DataCorrectionSubmitGrid from "../../../../../components/DataCorrectionSubmitGrid/DataCorrectionSubmitGrid";
import { Grid2 } from "@mui/material";
import logo from "../../../../../assets/logos/admin_logo.svg";
import { getRequestedValueLabel } from "../Helper/helper";
import { useEffect } from "react";
import { useState } from "react";
import { generateUUID } from "../../../../../utilities/helper";

const DataCorrectionConfirmation = ({
  setShowConfirm,
  id,
  data,
  correctionData,
  subjectName,
  isRemovedSubject = false,
  isFromDataCorrection = false,
}) => {
  const navigate = useNavigate();
  const [correctionTableData, setCorrectionTableData] = useState([]);

  useEffect(() => {
    if (!isRemovedSubject) {
      if (correctionData?.length > 0 && data) {
        const tempData = correctionData.map((item) => {
          const removeValue = data?.[item.removeFieldName] ?? false;
          return {
            ...item,
            requestedValue:
              getRequestedValueLabel(item, data) !== ""
                ? getRequestedValueLabel(item, data)
                : item.requestedValue,
            removeValue,
          };
        });
        // .filter((item) => !item.removeValue);

        setCorrectionTableData(tempData);
      }
    } else {
      let arr = [
        {
          answer_id: generateUUID(),
          fieldName: "The Selected Subject will be removed",
          currentValue: "Enrolled",
          requestedValue: "Removed",
        },
      ];
      setCorrectionTableData(arr);
    }
  }, [correctionData, data]);

  const email = localStorage.getItem("email");

  return (
    <div className="content-body">
      <p className="bread-crumbs-link-container">
        <button className="bread-crumbs-btn" onClick={() => navigate("/")}>
          Home
        </button>{" "}
        {!isFromDataCorrection && (
          <>
            |{" "}
            <button
              className="bread-crumbs-btn"
              onClick={(e) => {
                navigate("/subject");
              }}
            >
              Subject Management
            </button>
            {" | "}
            <button
              className="bread-crumbs-btn"
              onClick={(e) =>
                navigate("/update-subject", {
                  state: {
                    id: id,
                  },
                })
              }
            >
              {subjectName}
            </button>{" "}
          </>
        )}
        |{" "}
        <button
          className="bread-crumbs-btn"
          onClick={() => navigate("/data-corrections")}
        >
          Data Correction
        </button>
        |{" "}
        <button
          className="bread-crumbs-btn"
          onClick={() => setShowConfirm(false)}
        >
          Data Correction Confirmation
        </button>
        -<b style={{ color: "gray" }}>{localStorage?.getItem("studyName")}</b>
      </p>
      <Grid2
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{ width: "100%", margin: "0 auto" }}
      >
        <Grid2 item md={6}>
          <p className="page-heading">
            Dev-Genesis StudyPortal Confirmation of Data Correction Form
            (Pending Approval)
          </p>
        </Grid2>
      </Grid2>
      <div className="heading-container">
        <h4>Confirmation of Data Correction Form Genesis StudyPortal</h4>
      </div>
      <div className="inner-heading-container">
        <img className="admin-logo logo-image" src={logo} alt="Genesis Logo" />
        <div className="data-block">
          <div className="data-inner-block">
            <span
              className="data-inner-block-text"
              style={{
                display: "block",
                width: "210px",
                textAlign: "right",
              }}
            >
              User Name :{" "}
            </span>
            <span
              style={{
                color: "white",
                textAlign: "left",
              }}
            >
              {" "}
              {email}
            </span>
          </div>

          <div className="data-inner-block">
            <span
              className="data-inner-block-text"
              style={{
                display: "block",
                width: "210px",
                textAlign: "right",
              }}
            >
              System Transaction Date :
            </span>
            <span
              style={{
                color: "white",
                textAlign: "left",
              }}
            >
              {" "}
              {new Date().toLocaleDateString()}
            </span>
          </div>
        </div>
      </div>

      <div>
        <DataCorrectionSubmitGrid
          tableData={correctionTableData}
          isSubjectRemoved={isRemovedSubject}
        />
      </div>

      <div
        style={{
          height: "20px",
        }}
      ></div>
      <div className="footer-container">
        <span>
          Genesis {new Date().getFullYear()}-Please contact Genesis Support for
          assistance at Genesis.com/support
        </span>
      </div>
      <div
        style={{
          textAlign: "left",
          margin: "10px",
          fontSize: "10px",
        }}
      >
        You will receive an email confirmation of this transaction.
      </div>
      <Grid2
        alignItems={"center"}
        justifyContent="center"
        container
        gap={3}
        sx={{ marginTop: "2%" }}
      >
        <Grid2 item md={6}>
          <button
            className="create-btn"
            onClick={() => {
              navigate("/");
            }}
          >
            Home
          </button>
        </Grid2>
      </Grid2>
    </div>
  );
};

export default DataCorrectionConfirmation;
